module.exports = __webpack_public_path__ + "static/media/user_input.bc1dae65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WaterDefTool/user_input.png
// module id = 1752
// module chunks = 0